<div class="cont-center">
  <div class="sa-ticket-details" sa-fill *ngIf="ticketExists()">
    <div class="sa-ticket-details-top">
      <ssp-ticket-header #headerTicket [ticket]="ticket" [editable]="isNew()"></ssp-ticket-header>
    </div>

    <div class="sa-ticket-details-body">
      <div class="sa-activity-list">
        <div class="activity">
          <ssp-ticket-details-description #descriptionTicket [ticket]="ticket" [editable]="isNew()">
          </ssp-ticket-details-description>
          <xs-activity-list
            *ngIf="!isNew()"
            [activities]="ticketContextService.activities"
            [canEdit]="true"
            [isSPPMode]="true"
          ></xs-activity-list>

          <div *ngIf="isNew()">
            <div *ngFor="let activity of ticketContextService.activities" class="activityWrapper">
              <ssp-local-attachment-activity
                [file]="activity.$$file"
                [parentActivity]="activity"
                (onDelete)="delete($event)"
                (onError)="setError(error, canRetry)"
              >
              </ssp-local-attachment-activity>
            </div>
          </div>
        </div>
      </div>
      <div class="details-buttons" *ngIf="isNew()">
        <span class="error-message">{{ errorMessage }}</span>
        <button type="button" class="details-cancel" (click)="cancelSubmit()" [disabled]="isSubmitting">
          <span>{{ 'xs_cancel_label_short' | xsI18n }}</span>
        </button>
        <button type="button" class="details-submit" (click)="submitIncident()" [disabled]="isSubmitting">
          <span>{{ 'ticket_Edit_Submit_Incident' | xsI18n }}</span>
        </button>
      </div>
    </div>
  </div>

  <div class="top-buffer-lg" *ngIf="ticket?.isDeleted">
    <div class="error-col"></div>
    <div class="panel panel-danger error-col">
      <div class="panel-body text-danger">
        <h3>
          <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> {{ 'ticket_DoesNotExist_Message' | xsI18n }}
        </h3>
      </div>
    </div>
    <div class="error-col"></div>
  </div>
</div>
